import { render, staticRenderFns } from "./BidPriceOfferColumnContentForm.vue?vue&type=template&id=2f5da4e0"
import script from "./BidPriceOfferColumnContentForm.vue?vue&type=script&lang=js"
export * from "./BidPriceOfferColumnContentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports